import { useMemo } from 'react';
import { LABELS } from './labels';
import { ELabelType, ILabelsProps } from '../../../types/labels';
import { useApplicationContext } from '../../../utils/applicationContext';

export const useLabels = (builderId: number) => {
  const { config } = useApplicationContext();

  const openVillageBuilders = config.get<number[]>('countryside.openVillage.companyIds');
  const reliableBuilders = config.get<number[]>('countryside.reliableBuilders');
  const escrowBuilders = config.get<number[]>('Countryside.EscrowBuilders');

  return useMemo(() => {
    const labels: ILabelsProps[] = [];

    if (openVillageBuilders?.includes(builderId)) {
      labels.push(LABELS[ELabelType.OpenVillage]);
    }

    if (reliableBuilders?.includes(builderId)) {
      labels.push(LABELS[ELabelType.Reliable]);
    }

    if (escrowBuilders?.includes(builderId)) {
      labels.push(LABELS[ELabelType.Escrow]);
    }

    return labels;
  }, [builderId, openVillageBuilders, escrowBuilders, reliableBuilders]);
};
